"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.BorderLink = void 0;
var react_1 = __importDefault(require("react"));
var components_1 = require("components");
var BorderLink = function () { return (react_1.default.createElement("div", null,
    react_1.default.createElement(components_1.Link, { to: "border" }, "Border"))); };
exports.BorderLink = BorderLink;
